/* eslint-disable no-underscore-dangle */
class PollerUtil {
  constructor() {
    this._interval = null;
    this._pollingHandler = null;
    this.stop = false;
  }

  interval(interval) {
    this._interval = interval;
    return this;
  }

  async exec(func) {
    await func();
    await this.setTimeoutPromise(this._interval);
    clearTimeout(this._pollingHandler);
    if (!this.stop) {
      this.exec(func);
    }
    this.stop = false;
  }

  async setTimeoutPromise(timeout) {
    return new Promise((resolve) => {
      this._pollingHandler = setTimeout(resolve, timeout);
    });
  }

  end() {
    this.stop = true;
    return true;
  }
}

export const Class = PollerUtil;
export default new PollerUtil();
